import { ErrorMessage, useField, useFormikContext } from "formik";
import React from "react";
import QuestionCopy from "./QuestionCopy";
import QuestionWrapper from "./QuestionWrapper";
import ReactInputDateMask from "react-input-date-mask";
import styles from "./DateInput.module.scss";

const debug = false;

type TDateFieldProps = {
  name: string;
  label?: string;
  note?: string;
  error?: boolean;
};

export default function DateInput({ name, label, note, error }: TDateFieldProps) {
  const { setFieldValue } = useFormikContext();
  const [field] = useField(name);
  const [displayText, setDisplayText] = React.useState("");

  React.useEffect(() => {
    if (displayText === "" && field.value !== "") {
      const dateFromValue = new Date(field.value);
      setDisplayText(dateFromValue.toLocaleString("en-AU").split(",")[0]);
    }
  }, [setDisplayText, field.value, displayText]);

  return (
    <QuestionWrapper flex>
      <QuestionCopy name={name} label={label} note={note} />
      <ReactInputDateMask
        className={styles.dateInput}
        name={name}
        showMaskOnFocus={true}
        value={displayText}
        onChange={(val) => {
          setDisplayText(val);
          try {
            debug && console.log(field.name, val);
            let splitDateString = val.split("/");
            if (splitDateString.length === 3) {
              const [day, month, year] = splitDateString;
              const parsedTimestamp = Date.parse(`${month}/${day}/${year}`);
              if (!isNaN(parsedTimestamp)) {
                const parsedDate = new Date(parsedTimestamp);
                debug && console.log("parsedDate " + field.name, parsedDate);
                setFieldValue(field.name, parsedDate);
              } else {
                setFieldValue(field.name, "");
              }
            }
          } catch (e) {
            console.error("Erroring Parsing Date Field", e);
          }
        }}
        mask="dd/mm/yyyy"
      />
      <ErrorMessage name={name}>
        {(msg) => <p style={{ fontSize: "14px", color: "#D82727", marginBottom: 0 }}>{msg}</p>}
      </ErrorMessage>
    </QuestionWrapper>
  );
}
